import React from 'react';

interface ICarIconProps {
	size?: string;
	active?: boolean;
}

export const Car = ({ size = '106', active = false }: ICarIconProps) => {
	return active ? (
		<svg
			role="img"
			width={size}
			height={size}
			viewBox="0 0 106 106"
			fill="none"
			aria-labelledby="carActiveIllustrationTitle">
			<title id="carActiveIllustrationTitle">car illustration</title>
			<path
				d="M2.80153 67.498L2.63957 62.4067C2.59222 60.9149 2.90924 59.4453 3.53788 58.2424C4.16653 57.0396 5.06887 56.176 6.09474 55.7955L13.221 53.1359C13.221 53.1359 26.6638 45.2329 35.0318 43.9411C41.5642 42.9532 49.2303 42.6492 53.0094 43.4851C56.7885 44.321 68.5577 47.2846 77.7894 57.7713C77.7894 57.7713 89.7206 60.203 97.4947 63.0146C105.269 65.8262 104.999 69.5498 104.999 69.5498V80.1884C104.999 80.1884 104.999 83 99.7082 83H79.463H11.6554H9.172C7.54905 82.9928 5.9684 82.2708 4.65168 80.9353C3.33496 79.5998 2.3482 77.7177 1.82977 75.553C1.45186 73.7292 1.12794 72.4374 1.12794 72.4374C0.970428 71.7582 0.958073 71.0289 1.09244 70.3399C1.2268 69.6509 1.50197 69.0327 1.88376 68.5619L2.80153 67.498Z"
				fill="#F9F9F9"
				stroke="#707070"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M36.9898 75.5948C33.9204 74.8609 27.7177 64.8925 25 60H72V72.3841C72 74.5857 70.0816 75.4419 69.1225 75.5948C59.6905 75.9006 40.0592 76.3287 36.9898 75.5948Z"
				fill="#DDDDDD"
			/>
			<path
				d="M3.52815 67H7.23476C7.70293 67 8.15194 66.842 8.48299 66.5607C8.81403 66.2794 9 65.8978 9 65.5C9 65.1022 8.81403 64.7206 8.48299 64.4393C8.15194 64.158 7.70293 64 7.23476 64H3"
				stroke="#707070"
				strokeWidth="2"
			/>
			<path
				d="M104.87 77H101.753C101.523 77 101.295 76.9605 101.082 76.8837C100.87 76.8069 100.676 76.6943 100.513 76.5524C100.351 76.4105 100.222 76.242 100.133 76.0566C100.045 75.8711 100 75.6724 100 75.4717V75.4717C100.017 75.0762 100.209 74.7019 100.536 74.4274C100.863 74.1529 101.299 73.9997 101.753 74H105"
				stroke="#707070"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M102 65.7824C101.849 66.4502 99.3617 67.6857 96.9444 66.5171C95.4337 65.7937 95.0504 64.1686 95 63"
				stroke="#707070"
				strokeWidth="2"
			/>
			<path
				d="M71.0234 72.1623C71.0234 73.189 70.7199 74.1736 70.1797 74.8996C69.6395 75.6256 68.9068 76.0334 68.1429 76.0334H52.8613H37.5798C35.578 76.0334 29.1454 67.4722 27.3389 63.9947C27.1924 63.6666 26.6554 62.5512 25.1907 59.0082L24.5072 57.4335C24.2964 56.9365 24.227 56.3537 24.3119 55.7931C24.3596 55.3876 24.4897 55.0076 24.6878 54.695C24.886 54.3824 25.1444 54.1494 25.4348 54.0216C30.073 51.9876 33.7835 50.741 36.5176 50.3473C39.2517 49.9536 43.6457 49.56 46.9169 49.56C48.6792 49.5207 50.4414 49.6522 52.1897 49.9536C55.5097 50.6097 64.0537 52.8406 71.3283 59.4018L71.0234 72.1623Z"
				stroke="#707070"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M46.9103 49.5601C43.6383 49.5601 39.8291 49.8959 36.5082 50.366C33.1874 50.836 30.0619 52.0448 25.4224 54.1266C25.1884 54.2478 24.9758 54.4363 24.799 54.6795C24.6221 54.9227 24.4851 55.215 24.3969 55.5368C24.3033 55.8615 24.2635 56.2108 24.2804 56.5593C24.2973 56.9077 24.3704 57.2467 24.4946 57.5514L25.1783 59.2303C25.2485 59.4185 25.3302 59.5982 25.4224 59.7675H71.3283V59.6332C64.0517 52.9178 55.5054 50.6346 52.1846 49.963C50.4358 49.6546 48.6731 49.5199 46.9103 49.5601Z"
				fill="#ffcc00"
				stroke="#707070"
				strokeWidth="2"
			/>
			<path d="M0 90L106 90" stroke="#707070" strokeWidth="2" strokeLinejoin="round" />
			<path
				d="M25.5 89C29.6421 89 33 85.6421 33 81.5C33 77.3579 29.6421 74 25.5 74C21.3579 74 18 77.3579 18 81.5C18 85.6421 21.3579 89 25.5 89Z"
				fill="white"
				stroke="#707070"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M25.5 87C28.5376 87 31 84.5376 31 81.5C31 78.4624 28.5376 76 25.5 76C22.4624 76 20 78.4624 20 81.5C20 84.5376 22.4624 87 25.5 87Z"
				fill="#EFEFEF"
			/>
			<path
				d="M22 81.7825C22.0024 82.5818 22.2486 83.3597 22.7031 84.0046C23.1577 84.6496 23.7973 85.1283 24.53 85.3722"
				stroke="#707070"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				d="M29.1583 82.744C29.2594 82.435 29.3014 82.1083 29.2817 81.7825C29.29 81.2835 29.2016 80.7878 29.0216 80.325C28.8416 79.8622 28.5737 79.4419 28.2339 79.0889C27.8942 78.736 27.4895 78.4577 27.044 78.2708C26.5985 78.0838 26.1213 77.9919 25.6409 78.0006"
				stroke="#707070"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				d="M87.5 89C91.6421 89 95 85.6421 95 81.5C95 77.3579 91.6421 74 87.5 74C83.3579 74 80 77.3579 80 81.5C80 85.6421 83.3579 89 87.5 89Z"
				fill="white"
				stroke="#707070"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M87.5 87C90.5376 87 93 84.5376 93 81.5C93 78.4624 90.5376 76 87.5 76C84.4624 76 82 78.4624 82 81.5C82 84.5376 84.4624 87 87.5 87Z"
				fill="#EFEFEF"
			/>
			<path
				d="M84 81.7825C84.0024 82.5818 84.2486 83.3597 84.7031 84.0046C85.1577 84.6496 85.7973 85.1283 86.53 85.3722"
				stroke="#707070"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				d="M91.1583 82.744C91.2594 82.435 91.3014 82.1083 91.2817 81.7825C91.29 81.2835 91.2016 80.7878 91.0216 80.325C90.8416 79.8622 90.5737 79.4419 90.2339 79.0889C89.8942 78.736 89.4895 78.4577 89.044 78.2708C88.5985 78.0838 88.1213 77.9919 87.6409 78.0006"
				stroke="#707070"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				d="M44.7385 49.8207L46.8454 59.702C47.4734 61.9797 47.7966 64.368 47.8024 66.7734C47.696 70.5056 47.8024 75.5654 47.8024 75.5654"
				stroke="#707070"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M61.75 61.426H64.4577C65.3218 61.426 66.0222 60.7263 66.0222 59.8631V59.809C66.0222 58.9459 65.3218 58.2462 64.4577 58.2462H61.75C60.8859 58.2462 60.1855 58.9459 60.1855 59.809V59.8631C60.1855 60.7263 60.8859 61.426 61.75 61.426Z"
				fill="#F9F9F9"
				stroke="#707070"
				strokeWidth="2"
			/>
			<path d="M0 37H5" stroke="#707070" strokeWidth="2" />
			<path d="M8 37H22" stroke="#707070" strokeWidth="2" />
			<path d="M32 29H50" stroke="#707070" strokeWidth="2" />
		</svg>
	) : (
		<svg
			role="img"
			width={size}
			height={size}
			viewBox="0 0 106 106"
			fill="none"
			aria-labelledby="carIllustrationTitle">
			<title id="carIllustrationTitle">car illustration</title>
			<path
				d="M2.80153 67.498L2.63957 62.4067C2.59222 60.9149 2.90924 59.4453 3.53788 58.2424C4.16653 57.0396 5.06887 56.176 6.09474 55.7955L13.221 53.1359C13.221 53.1359 26.6638 45.2329 35.0318 43.9411C41.5642 42.9532 49.2303 42.6492 53.0094 43.4851C56.7885 44.321 68.5577 47.2846 77.7894 57.7713C77.7894 57.7713 89.7206 60.203 97.4947 63.0146C105.269 65.8262 104.999 69.5498 104.999 69.5498V80.1884C104.999 80.1884 104.999 83 99.7082 83H79.463H11.6554H9.172C7.54905 82.9928 5.9684 82.2708 4.65168 80.9353C3.33496 79.5998 2.3482 77.7177 1.82977 75.553C1.45186 73.7292 1.12794 72.4374 1.12794 72.4374C0.970428 71.7582 0.958073 71.0289 1.09244 70.3399C1.2268 69.6509 1.50197 69.0327 1.88376 68.5619L2.80153 67.498Z"
				fill="#F9F9F9"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M36.9898 75.5948C33.9204 74.8609 27.7177 64.8925 25 60H72V72.3841C72 74.5857 70.0816 75.4419 69.1225 75.5948C59.6905 75.9006 40.0592 76.3287 36.9898 75.5948Z"
				fill="#DDDDDD"
			/>
			<path
				d="M3.52815 67H7.23476C7.70293 67 8.15194 66.842 8.48299 66.5607C8.81403 66.2794 9 65.8978 9 65.5C9 65.1022 8.81403 64.7206 8.48299 64.4393C8.15194 64.158 7.70293 64 7.23476 64H3"
				stroke="#A6A6A6"
				strokeWidth="2"
			/>
			<path
				d="M104.87 77H101.753C101.523 77 101.295 76.9605 101.082 76.8837C100.87 76.8069 100.676 76.6943 100.513 76.5524C100.351 76.4105 100.222 76.242 100.133 76.0566C100.045 75.8711 100 75.6724 100 75.4717V75.4717C100.017 75.0762 100.209 74.7019 100.536 74.4274C100.863 74.1529 101.299 73.9997 101.753 74H105"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M102 65.7824C101.849 66.4502 99.3617 67.6857 96.9444 66.5171C95.4337 65.7937 95.0504 64.1686 95 63"
				stroke="#A6A6A6"
				strokeWidth="2"
			/>
			<path
				d="M71.0232 72.1623C71.0232 73.189 70.7197 74.1737 70.1795 74.8996C69.6393 75.6256 68.9066 76.0335 68.1426 76.0335H52.8611H37.5795C35.5778 76.0335 29.1451 67.4722 27.3387 63.9947C27.1922 63.6667 26.6551 62.5513 25.1904 59.0082L24.5069 57.4335C24.2962 56.9365 24.2268 56.3537 24.3116 55.7932C24.3594 55.3876 24.4895 55.0076 24.6876 54.695C24.8857 54.3825 25.1442 54.1494 25.4346 54.0216C30.0727 51.9876 33.7833 50.741 36.5174 50.3473C39.2514 49.9537 43.6455 49.56 46.9166 49.56C48.679 49.5207 50.4412 49.6523 52.1895 49.9537C55.5094 50.6098 64.0534 52.8406 71.328 59.4019L71.0232 72.1623Z"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M46.91 49.5602C43.638 49.5602 39.8288 49.8959 36.508 50.366C33.1871 50.8361 30.0616 52.0448 25.4222 54.1266C25.1881 54.2478 24.9756 54.4363 24.7987 54.6795C24.6219 54.9227 24.4848 55.215 24.3967 55.5368C24.3031 55.8615 24.2633 56.2108 24.2802 56.5593C24.297 56.9078 24.3702 57.2467 24.4943 57.5514L25.178 59.2303C25.2483 59.4185 25.33 59.5982 25.4222 59.7675H71.328V59.6332C64.0515 52.9178 55.5052 50.6346 52.1843 49.9631C50.4356 49.6546 48.6729 49.52 46.91 49.5602Z"
				fill="white"
				stroke="#A6A6A6"
				strokeWidth="2"
			/>
			<path d="M0 90L106 90" stroke="#A6A6A6" strokeWidth="2" strokeLinejoin="round" />
			<path
				d="M25.5 89C29.6421 89 33 85.6421 33 81.5C33 77.3579 29.6421 74 25.5 74C21.3579 74 18 77.3579 18 81.5C18 85.6421 21.3579 89 25.5 89Z"
				fill="white"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M25.5 87C28.5376 87 31 84.5376 31 81.5C31 78.4624 28.5376 76 25.5 76C22.4624 76 20 78.4624 20 81.5C20 84.5376 22.4624 87 25.5 87Z"
				fill="#EFEFEF"
			/>
			<path
				d="M22 81.7825C22.0024 82.5818 22.2486 83.3597 22.7031 84.0046C23.1577 84.6496 23.7973 85.1283 24.53 85.3722"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				d="M29.158 82.744C29.2592 82.435 29.3011 82.1083 29.2814 81.7825C29.2898 81.2835 29.2013 80.7878 29.0213 80.325C28.8413 79.8622 28.5734 79.4419 28.2337 79.0889C27.8939 78.736 27.4892 78.4577 27.0437 78.2708C26.5982 78.0838 26.121 77.9919 25.6406 78.0006"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				d="M87.5 89C91.6421 89 95 85.6421 95 81.5C95 77.3579 91.6421 74 87.5 74C83.3579 74 80 77.3579 80 81.5C80 85.6421 83.3579 89 87.5 89Z"
				fill="white"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M87.5 87C90.5376 87 93 84.5376 93 81.5C93 78.4624 90.5376 76 87.5 76C84.4624 76 82 78.4624 82 81.5C82 84.5376 84.4624 87 87.5 87Z"
				fill="#EFEFEF"
			/>
			<path
				d="M84 81.7825C84.0024 82.5818 84.2486 83.3597 84.7031 84.0046C85.1577 84.6496 85.7973 85.1283 86.53 85.3722"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				d="M91.158 82.744C91.2592 82.435 91.3011 82.1083 91.2814 81.7825C91.2898 81.2835 91.2013 80.7878 91.0213 80.325C90.8413 79.8622 90.5734 79.4419 90.2337 79.0889C89.8939 78.736 89.4892 78.4577 89.0437 78.2708C88.5982 78.0838 88.121 77.9919 87.6406 78.0006"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				d="M44.7388 49.8206L46.8456 59.7019C47.4736 61.9796 47.7968 64.3679 47.8026 66.7733C47.6963 70.5055 47.8026 75.5652 47.8026 75.5652"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M61.7497 61.426H64.4575C65.3215 61.426 66.022 60.7263 66.022 59.8632V59.8091C66.022 58.946 65.3215 58.2462 64.4575 58.2462H61.7497C60.8857 58.2462 60.1852 58.946 60.1852 59.8091V59.8632C60.1852 60.7263 60.8857 61.426 61.7497 61.426Z"
				fill="#F9F9F9"
				stroke="#A6A6A6"
				strokeWidth="2"
			/>
			<path d="M0 37H5" stroke="#A6A6A6" strokeWidth="2" />
			<path d="M8 37H22" stroke="#A6A6A6" strokeWidth="2" />
			<path d="M32 29H50" stroke="#A6A6A6" strokeWidth="2" />
		</svg>
	);
};
